<ejs-dialog #thirdPartyUserAssignmentDialog [isModal]="true" [showCloseIcon]="true" [visible]="false">
  <ng-template #header>
    {{ (isAdd ? 'i18n.domain.third-party-user-assignment-administration.dialog.add-title' : 'i18n.domain.third-party-user-assignment-administration.dialog.delete-title') | translate}}
  </ng-template>
  <ng-template #content>
    <form id="thirdPartyUserAssignmentForm" [formGroup]="form" autocomplete="off">
      <div class="row">
        <div class="form-group col-6">
          <label class="control-label required">{{'i18n.domain.third-party-user-assignment-administration.dialog.user' | translate}}</label>
          <app-autocomplete #userAutocomplete [getDataFunction]="getThirdPartyUsers.bind(this)"
            [(value)]="selectedUser" [isFormComponent]="true" placeholder="" id="user">
          </app-autocomplete>
        </div>
        <div class="form-group col-6">
          <label class="control-label required">{{'i18n.domain.third-party-user-assignment-administration.dialog.client' | translate}}</label>
          <app-client-autocomplete class="client-autocomplete" [formControl]="form.controls.client"
            placeholder=""></app-client-autocomplete>
          <app-error-messages [control]="form.controls.client"></app-error-messages>
        </div>
      </div>
    </form>
    @if (isAdd && form.controls.client.value) {
      <div>
        <ejs-tooltip id='tooltip' content="{{ 'i18n.domain.third-party-user-assignment-administration.dialog.zone-selection-tooltip' | translate }}">
          <span>{{'i18n.domain.third-party-user-assignment-administration.dialog.zone-selection' | translate}}</span><span class="icon-information"></span>
        </ejs-tooltip>
        <app-third-party-user-assignment-edit-zones-selector [clientId]="form.controls.client.value.id"></app-third-party-user-assignment-edit-zones-selector>
      </div>
    }
  </ng-template>
  <ng-template #footerTemplate>
    <button class="btn btn-secondary me-2" (click)="closeDialog()">
      {{'i18n.shared.cancel' | translate}}
    </button>
    <button class="btn btn-primary" (click)="onExecute()" [disabled]="form.invalid">
      {{'i18n.shared.save' | translate}}
    </button>
  </ng-template>
</ejs-dialog>
